import { Select } from "@jkast90/kast-common/ui";
import styles from "./DisplayModeSelect.module.css";

export type DisplayMode = "grouped" | "compact";

const OPTIONS = [
  { value: "grouped", label: "Grouped", icon: "☰" },
  { value: "compact", label: "Compact", icon: "⋮⋮" },
] as const;

/**
 * The Grouped / Compact switch in a page's toolbar: kast-common's Select, small,
 * named by `label` (the old button's title).
 */
export default function DisplayModeSelect<T extends DisplayMode>({
  value,
  onChange,
  label,
}: {
  value: T;
  onChange: (mode: T) => void;
  label: string;
}) {
  return (
    <div className={`${styles.displayMode} display-mode-toggle`}>
      <Select<DisplayMode>
        size="sm"
        aria-label={label}
        options={OPTIONS.map((o) => ({ ...o }))}
        value={value}
        onChange={(mode) => onChange(mode as T)}
      />
    </div>
  );
}
